
    <!--
 * 横版-首充领奖
 * @LastEditTime: Mon Mar 31 2025 17:10:42 GMT+0800 (中国标准时间)
 -->
 <template>
  <div id="u_c_V3GG18"  :class="[`normal`,`u_c_V3GG18`]" ><div id="u_c_CKWA23"  :class="[`${ compData.title ? 'text' : '' }`,`normal `,`u_c_CKWA23`]" ><div id="u_c_CXUG28"  v-html="compData.title" :class="[`normal`,`u_c_CXUG28`]" ></div></div><div id="u_c_09F017"  v-html="compData.subTitle" :class="[`normal`,`u_c_09F017`]" ></div><div id="u_c_EGBY17"  :style="`background-image:url(${ compData.giftIcon })`" :class="[`normal`,`u_c_EGBY17`]" ></div><a id="u_c_0LM773" href="javascript:;" :style="`background-image:url(${ pageData['common-btn-bg'] })`" :class="[`${ pageData.firstPayState == 2 && pageData.firstPayType != 'sendCoupon' ? 'has' : 'btn-light' }`,`normal  `,`u_c_0LM773`]" @click="u_c_0LM773_event_NP9I65($event)"><div id="u_c_ZVYG26"  :class="[`normal page-common-btn`,`u_c_ZVYG26`]" ><div id="u_c_TMWV33"  v-show="pageData.firstPayState != 2" :class="[`normal `,`u_c_TMWV33`]" >{{`${ langData.getBtn }`}}</div><div id="u_c_NRLX34"  v-show="pageData.firstPayState == 2 && pageData.firstPayType != 'sendCoupon'" :class="[`normal `,`u_c_NRLX34`]" >{{`${ langData.hasBtn }`}}</div><div id="u_c_TWQV36"  v-show="pageData.firstPayState == 2 && pageData.firstPayType == 'sendCoupon'" :class="[`normal `,`u_c_TWQV36`]" >{{`${ langData.useBtn }`}}</div></div></a></div>
  </template>
<script setup>
import {reactive,provide,inject,onMounted,watch,watchEffect,ref,computed,nextTick,readonly,toRaw,markRaw} from "vue";
import * as vueUse from "@vueuse/core";
import Language from "@/hooks/language.js";
import Router from "@/hooks/router.js";
import bridge from "@/utils/sdkBridge.js";
import { useRoute } from 'vue-router';
import * as request from "@/api/request";
import * as utils from "@/utils";
import * as _ from "lodash-es";


    const { curLang, getLangTxt,langData } = Language();
    const routerData = inject("routerData",{});
    const pageData = inject("pageData", {});
    const COMP_DATA_LANG = {"default":{"subTitle":`活动期间，通过官网渠道成功储值任意金额即可领取xxxxxx`,"giftIcon":`https://cdnimages.awselbcombine.com/public_images/one_image/2025/03/174339360539630028.png`,"giftName":`首储礼包`,"title":`成神归来
每日赠礼`},"zh-CN":{"subTitle":`活动期间，通过【官网储值页面】任意渠道成功储值任意金额，即可领取奖励，每个账号只能领取一次；`,"giftIcon":`https://cdnimages.awselbcombine.com/public_images/one_image/2025/03/174339360539630028.png`,"giftName":`加速训练5分钟*10
研发加速5分钟*10`,"title":`超值首储赠好礼`},"zh-TW":{"subTitle":`活動期間，通過【官網儲值頁面】任意管道成功儲值任意金額，即可領取獎勵，每個帳號只能領取一次；`,"giftIcon":`https://cdnimages.awselbcombine.com/public_images/one_image/2025/03/174339360539630028.png`,"giftName":`加速訓練5分鐘*10
研發加速5分鐘*10`,"title":`超值首儲贈好禮`},"en-US":{"subTitle":`During the event, top up on Puzzles & Survival's official website to obtain a reward. The reward can only be claimed once per account.`,"giftIcon":`https://cdnimages.awselbcombine.com/public_images/one_image/2025/03/174339360539630028.png`,"giftName":`5-min Training Speedup*10
5-min Research Speedup*10`,"title":`1st Top-up Reward`},"ja-JP":{"subTitle":`イベント期間中、「公式チャージ画面」にて任意の決済方法で任意の金額をチャージすると、ボーナスを受け取れます！（1つのアカウントにつき1回のみ）`,"giftIcon":`https://cdnimages.awselbcombine.com/public_images/one_image/2025/03/174339360539630028.png`,"giftName":`訓練ブースト（5分間）*10
研究ブースト（5分間）*10`,"title":`初回チャージギフトGET`},"ko-KR":{"subTitle":`이벤트 기간에 공식 결제 플랫폼에서 금액 관계 없이 충전만 하면 보상을 획득합니다. (계정당 한 번만 가능!)`,"giftIcon":`https://cdnimages.awselbcombine.com/public_images/one_image/2025/03/174339360539630028.png`,"giftName":`훈련 5분 가속*10
개발 5분 가속*10`,"title":`혜택 가득 첫 충전`},"th-TH":{"subTitle":`ช่วงกิจกรรม เพียงเติมเงินผ่าน [หน้าเพจเว็บไซต์ทางการ] สำเร็จ ก็สามารถรับรางวัลได้ (รับได้บัญชีละ 1 ครั้ง)`,"giftIcon":`https://cdnimages.awselbcombine.com/public_images/one_image/2025/03/174339360539630028.png`,"giftName":`เร่งสปีดฝึก5นาที*10
เร่งสปีดการวิจัย5นาที*10`,"title":`รางวัลเติมเงินครั้งแรกสุดคุ้ม`},"vi-VN":{"subTitle":`Trong thời gian hoạt động, nạp mức bất kỳ trên kênh bất kỳ là có thưởng, mỗi tài khoản chỉ được lấy một lần;`,"giftIcon":`https://cdnimages.awselbcombine.com/public_images/one_image/2025/03/174339360539630028.png`,"giftName":`Tăng tốc huấn luyện 5 phút*10
Tăng tốc nghiên cứu 5 phút*10`,"title":`Quà nạp đầu siêu giá trị`},"de-DE":{"subTitle":`Lade während des Events auf der offiziellen Webseite von Puzzles & Survival auf, um eine Belohnung zu erhalten. Die Belohnung kann nur einmal pro Konto abgeholt werden.`,"giftIcon":`https://cdnimages.awselbcombine.com/public_images/one_image/2025/03/174339360539630028.png`,"giftName":`5 Min Training Beschleunigen*10
5 Min Forschung Beschleunigen*10`,"title":`1. Aufladebelohnung`},"fr-FR":{"subTitle":`Pendant l'événement, rechargez votre compte sur le site officiel de Puzzles & Survival pour obtenir une récompense. La récompense ne peut être réclamée qu'une fois par compte.`,"giftIcon":`https://cdnimages.awselbcombine.com/public_images/one_image/2025/03/174339360539630028.png`,"giftName":`Accélération entraînement 5-min*10
Accélération recherche 5-min*10`,"title":`Récompense de 1ère Recharge`},"es-ES":{"subTitle":`Durante el evento, haz una recarga en el sitio web oficial de Puzzles & Survival para obtener una recompensa. La recompensa solo se puede reclamar una vez por cuenta.`,"giftIcon":`https://cdnimages.awselbcombine.com/public_images/one_image/2025/03/174339360539630028.png`,"giftName":`5 min de Aceleración de Entrenamiento*10
5 min de Aceleración de investigación*10`,"title":`Recompensa de la 1.ª recarga`},"pt-PT":{"subTitle":`Durante o evento, faça uma recarga no site oficial do Puzzles & Survival para obter uma recompensa. A recompensa só pode ser resgatada uma vez por conta.`,"giftIcon":`https://cdnimages.awselbcombine.com/public_images/one_image/2025/03/174339360539630028.png`,"giftName":`5 min de Aceleração de Treinamento*10
5 min de aceleração da Pesquisa*10`,"title":`1ª Recompensa de Recarga`},"it-IT":{"subTitle":`Durante l'evento, ricarica sul sito ufficiale di Puzzles & Survival per ottenere una ricompensa. Il premio può essere richiesto solo una volta per account.`,"giftIcon":`https://cdnimages.awselbcombine.com/public_images/one_image/2025/03/174339360539630028.png`,"giftName":`Velocizz. Addestramento 5-min*10
Velocizz. Ricerca 5-min*10`,"title":`Ricompensa 1ma Ricarica`},"tr-TR":{"subTitle":`Etkinlikte bir ödül almak için Puzzles & Survival'ın resmi sitesinde yükleme yap. Her hesap başına yalnızca bir kez ödül talep edilebilir.`,"giftIcon":`https://cdnimages.awselbcombine.com/public_images/one_image/2025/03/174339360539630028.png`,"giftName":`5-dk Eğitim Hızlandırma*10
5-dk Araştırma Hızlandırma*10`,"title":`1. Yükleme Ödülü`},"pl-PL":{"subTitle":`Podczas wydarzenia doładuj konto na oficjalnej stronie Puzzles & Survival, aby otrzymać nagrodę. Nagroda może być odebrana tylko raz na jedno konto.`,"giftIcon":`https://cdnimages.awselbcombine.com/public_images/one_image/2025/03/174339360539630028.png`,"giftName":`5-min. Przyśpieszenie Szkolenia*10
5-min. Przyśpieszenie Badań*10`,"title":`Nagroda 1wszego doładowania`},"id-ID":{"subTitle":`Laad tijdens het event op via de officiële website van Puzzles & Survival om een beloning te krijgen. De beloning kan slechts eenmaal per account worden geclaimd.`,"giftIcon":`https://cdnimages.awselbcombine.com/public_images/one_image/2025/03/174339360539630028.png`,"giftName":`Speed up Training 5 menit*10
Speed up R&D 5 menit*10`,"title":`1e Oplaad Beloning`},"ar-SA":{"subTitle":`Selama Event, lakukan Top Up berapa pun dan dengan cara pembayaran apa pun untuk klaim hadiah. Setiap akun hanya bisa klaim 1x.`,"giftIcon":`https://cdnimages.awselbcombine.com/public_images/one_image/2025/03/174339360539630028.png`,"giftName":`تسريع التدريب 5 دقائق*10
تسريع الأبحاث 5 دقائق*10`,"title":`Hadiah Top Up Perdana Berharga`}};
    const compData = reactive(COMP_DATA_LANG[curLang] || COMP_DATA_LANG['en-US']||{});
    let pagePlatform = "global"
    const router = Router();
    const route = useRoute();
    const compName = '首充领奖';

    // 自定义setup - 开始
    const checkIsBind = inject("checkIsBind", () => {})
const checkIsLogin = inject("checkIsLogin", () => {})
const listData = inject("listData", {})
const showTips = inject("showTips", (txt, code) => {})
const showGetSucc = inject("showGetSucc", (type, pic, name) => {})
const giftInfo = inject("giftInfo", {})
const getCurLink = inject("getCurLink", (link) => {})

giftInfo.firstPayAward = [{ name: compData.giftName }]
const curPlatform =pagePlatform;
const canClick = ref(true)


const getFirstGift = async () => {
  const link = {
    gm99: `https://eventsapi.gm99.com/activity/execute?name=${pageData.pageId}&action=firstPayAward`,
    global: `https://gactivityapi.${utils.getMainHost()}/activity/execute?name=${
      pageData.pageId
    }&action=firstPayAward`,
    omnion: `https://gactivityapi.${utils.getMainHost()}/activity/execute?name=${
      pageData.pageId
    }&action=firstPayAward`,
  }
  let res = await request.getJSON(link[curPlatform], {
    params: JSON.stringify({
      language: curLang,
    }),
  })
  if (res.result == 1) {
    pageData.firstPayState = 2
    let curGiftName = pageData.firstPayType == 'sendSerial' ?res.data.send_value :compData.giftName
    showGetSucc(pageData.firstPayType, compData.giftIcon, curGiftName)
  } else {
    showTips(getLangTxt(res.code, getLangTxt("common")), res.code)
  }
  return res.result == 1
}

;
      // 领取按钮的click事件
      const u_c_0LM773_event_NP9I65= async (e)=>{
        try {if (!checkIsLogin()) return;
if (!checkIsBind()) return;
if (+pageData.firstPayState > 1) {
  if (pageData.firstPayType == 'sendCoupon') {
    window.activityDataLayer.push({
      eventName: 'click_button',
      eventType: '前往使用优惠券',
      gameId: pageData.gameId,
      aid: pageData.pageId,
    });
    bridge.open(pageData.storeLink)
  }
  return;
}
if (!canClick.value) return;
canClick.value = false;
window.activityDataLayer.push({
  eventName: 'click_button',
  eventType: '领取首储奖励',
  gameId: pageData.gameId,
  aid: pageData.pageId,
});
await getFirstGift();
canClick.value = true;
} catch (error) {console.log(error)}
      }
    // 自定义setup - 结束


</script>
<style lang="scss" scoped>
.default{
.u_c_V3GG18.normal{
position:relative;
width:100.00vw;
height:49.95vw;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/03/1742191580954-2.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}
}.default{
.u_c_CKWA23.normal{
position:relative;
width:38.23vw;
height:9.95vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16715378206717.png);
margin:auto;
margin-top:2.55vw;
font-size:3.65vw;
color:#dbeaf0;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_CKWA23.normal.text{
width:100%;
height:auto;

}
}.default{
.u_c_CXUG28.normal{
position:relative;

}
}.default{
.u_c_09F017.normal{
position:relative;
margin-top:2.19vw;
line-height:1.5;
box-sizing:border-box;
padding:0 1.04vw;
font-size:1.15vw;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;

}
}.default{
.u_c_EGBY17.normal{
position:relative;
margin:auto;
margin-top:2.29vw;
background:no-repeat center;
background-size:contain;
width:25.52vw;
height:15.05vw;

}
}.default{
.u_c_0LM773.normal{
position:relative;
width:24.58vw;
height:7.34vw;
background:no-repeat center;
background-size:contain;
margin:auto;
text-align:center;
text-decoration:none;
margin-top:0.52vw;
display:block;
overflow:hidden;

}

.u_c_0LM773.normal.has{
filter:grayscale(1);

}
}.default{
.u_c_ZVYG26.normal{
position:relative;
margin:auto;
text-align:center;
margin-top:2.50vw;

}
}.default{
.u_c_TMWV33.normal{
position:relative;

}
}.default{
.u_c_NRLX34.normal{
position:relative;

}
}.default{
.u_c_TWQV36.normal{
position:relative;

}
}.zh-CN{
.u_c_V3GG18.normal{
position:relative;
width:100.00vw;
height:49.95vw;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/03/1742191580954-2.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}
}.zh-CN{
.u_c_CKWA23.normal{
position:relative;
width:38.23vw;
height:9.95vw;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:2.55vw;
font-size:3.65vw;
color:#dbeaf0;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_CKWA23.normal.text{
width:100%;
height:auto;

}
}.zh-CN{
.u_c_CXUG28.normal{
position:relative;

}
}.zh-CN{
.u_c_09F017.normal{
position:relative;
margin-top:2.19vw;
line-height:1.5;
box-sizing:border-box;
padding:0 1.04vw;
font-size:1.15vw;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;

}
}.zh-CN{
.u_c_EGBY17.normal{
position:relative;
margin:auto;
margin-top:2.29vw;
background:no-repeat center;
background-size:contain;
width:25.52vw;
height:15.05vw;

}
}.zh-CN{
.u_c_0LM773.normal{
position:relative;
width:24.58vw;
height:7.34vw;
background:no-repeat center;
background-size:contain;
margin:auto;
text-align:center;
text-decoration:none;
margin-top:0.52vw;
display:block;
overflow:hidden;

}

.u_c_0LM773.normal.has{
filter:grayscale(1);

}
}.zh-CN{
.u_c_ZVYG26.normal{
position:relative;
margin:auto;
text-align:center;
margin-top:2.50vw;

}
}.zh-CN{
.u_c_TMWV33.normal{
position:relative;

}
}.zh-CN{
.u_c_NRLX34.normal{
position:relative;

}
}.zh-CN{
.u_c_TWQV36.normal{
position:relative;

}
}.zh-TW{
.u_c_V3GG18.normal{
position:relative;
width:100.00vw;
height:49.95vw;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/03/1742191580954-2.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}
}.zh-TW{
.u_c_CKWA23.normal{
position:relative;
width:38.23vw;
height:9.95vw;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:2.55vw;
font-size:3.65vw;
color:#dbeaf0;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_CKWA23.normal.text{
width:100%;
height:auto;

}
}.zh-TW{
.u_c_CXUG28.normal{
position:relative;

}
}.zh-TW{
.u_c_09F017.normal{
position:relative;
margin-top:2.19vw;
line-height:1.5;
box-sizing:border-box;
padding:0 1.04vw;
font-size:1.15vw;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;

}
}.zh-TW{
.u_c_EGBY17.normal{
position:relative;
margin:auto;
margin-top:2.29vw;
background:no-repeat center;
background-size:contain;
width:25.52vw;
height:15.05vw;

}
}.zh-TW{
.u_c_0LM773.normal{
position:relative;
width:24.58vw;
height:7.34vw;
background:no-repeat center;
background-size:contain;
margin:auto;
text-align:center;
text-decoration:none;
margin-top:0.52vw;
display:block;
overflow:hidden;

}

.u_c_0LM773.normal.has{
filter:grayscale(1);

}
}.zh-TW{
.u_c_ZVYG26.normal{
position:relative;
margin:auto;
text-align:center;
margin-top:2.50vw;

}
}.zh-TW{
.u_c_TMWV33.normal{
position:relative;

}
}.zh-TW{
.u_c_NRLX34.normal{
position:relative;

}
}.zh-TW{
.u_c_TWQV36.normal{
position:relative;

}
}.en-US{
.u_c_V3GG18.normal{
position:relative;
width:100.00vw;
height:49.95vw;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/03/1742191580954-2.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}
}.en-US{
.u_c_CKWA23.normal{
position:relative;
width:38.23vw;
height:9.95vw;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:2.55vw;
font-size:3.65vw;
color:#dbeaf0;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_CKWA23.normal.text{
width:100%;
height:auto;

}
}.en-US{
.u_c_CXUG28.normal{
position:relative;

}
}.en-US{
.u_c_09F017.normal{
position:relative;
margin-top:2.19vw;
line-height:1.5;
box-sizing:border-box;
padding:0 1.04vw;
font-size:1.15vw;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;

}
}.en-US{
.u_c_EGBY17.normal{
position:relative;
margin:auto;
margin-top:2.29vw;
background:no-repeat center;
background-size:contain;
width:25.52vw;
height:15.05vw;

}
}.en-US{
.u_c_0LM773.normal{
position:relative;
width:24.58vw;
height:7.34vw;
background:no-repeat center;
background-size:contain;
margin:auto;
text-align:center;
text-decoration:none;
margin-top:0.52vw;
display:block;
overflow:hidden;

}

.u_c_0LM773.normal.has{
filter:grayscale(1);

}
}.en-US{
.u_c_ZVYG26.normal{
position:relative;
margin:auto;
text-align:center;
margin-top:2.50vw;

}
}.en-US{
.u_c_TMWV33.normal{
position:relative;

}
}.en-US{
.u_c_NRLX34.normal{
position:relative;

}
}.en-US{
.u_c_TWQV36.normal{
position:relative;

}
}.ja-JP{
.u_c_V3GG18.normal{
position:relative;
width:100.00vw;
height:49.95vw;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/03/1742191580954-2.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}
}.ja-JP{
.u_c_CKWA23.normal{
position:relative;
width:38.23vw;
height:9.95vw;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:2.55vw;
font-size:3.65vw;
color:#dbeaf0;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_CKWA23.normal.text{
width:100%;
height:auto;

}
}.ja-JP{
.u_c_CXUG28.normal{
position:relative;

}
}.ja-JP{
.u_c_09F017.normal{
position:relative;
margin-top:2.19vw;
line-height:1.5;
box-sizing:border-box;
padding:0 1.04vw;
font-size:1.15vw;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;

}
}.ja-JP{
.u_c_EGBY17.normal{
position:relative;
margin:auto;
margin-top:2.29vw;
background:no-repeat center;
background-size:contain;
width:25.52vw;
height:15.05vw;

}
}.ja-JP{
.u_c_0LM773.normal{
position:relative;
width:24.58vw;
height:7.34vw;
background:no-repeat center;
background-size:contain;
margin:auto;
text-align:center;
text-decoration:none;
margin-top:0.52vw;
display:block;
overflow:hidden;

}

.u_c_0LM773.normal.has{
filter:grayscale(1);

}
}.ja-JP{
.u_c_ZVYG26.normal{
position:relative;
margin:auto;
text-align:center;
margin-top:2.50vw;

}
}.ja-JP{
.u_c_TMWV33.normal{
position:relative;

}
}.ja-JP{
.u_c_NRLX34.normal{
position:relative;

}
}.ja-JP{
.u_c_TWQV36.normal{
position:relative;

}
}.ko-KR{
.u_c_V3GG18.normal{
position:relative;
width:100.00vw;
height:49.95vw;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/03/1742191580954-2.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}
}.ko-KR{
.u_c_CKWA23.normal{
position:relative;
width:38.23vw;
height:9.95vw;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:2.55vw;
font-size:3.65vw;
color:#dbeaf0;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_CKWA23.normal.text{
width:100%;
height:auto;

}
}.ko-KR{
.u_c_CXUG28.normal{
position:relative;

}
}.ko-KR{
.u_c_09F017.normal{
position:relative;
margin-top:2.19vw;
line-height:1.5;
box-sizing:border-box;
padding:0 1.04vw;
font-size:1.15vw;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;

}
}.ko-KR{
.u_c_EGBY17.normal{
position:relative;
margin:auto;
margin-top:2.29vw;
background:no-repeat center;
background-size:contain;
width:25.52vw;
height:15.05vw;

}
}.ko-KR{
.u_c_0LM773.normal{
position:relative;
width:24.58vw;
height:7.34vw;
background:no-repeat center;
background-size:contain;
margin:auto;
text-align:center;
text-decoration:none;
margin-top:0.52vw;
display:block;
overflow:hidden;

}

.u_c_0LM773.normal.has{
filter:grayscale(1);

}
}.ko-KR{
.u_c_ZVYG26.normal{
position:relative;
margin:auto;
text-align:center;
margin-top:2.50vw;

}
}.ko-KR{
.u_c_TMWV33.normal{
position:relative;

}
}.ko-KR{
.u_c_NRLX34.normal{
position:relative;

}
}.ko-KR{
.u_c_TWQV36.normal{
position:relative;

}
}.th-TH{
.u_c_V3GG18.normal{
position:relative;
width:100.00vw;
height:49.95vw;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/03/1742191580954-2.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}
}.th-TH{
.u_c_CKWA23.normal{
position:relative;
width:38.23vw;
height:9.95vw;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:2.55vw;
font-size:3.65vw;
color:#dbeaf0;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_CKWA23.normal.text{
width:100%;
height:auto;

}
}.th-TH{
.u_c_CXUG28.normal{
position:relative;

}
}.th-TH{
.u_c_09F017.normal{
position:relative;
margin-top:2.19vw;
line-height:1.5;
box-sizing:border-box;
padding:0 1.04vw;
font-size:1.15vw;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;

}
}.th-TH{
.u_c_EGBY17.normal{
position:relative;
margin:auto;
margin-top:2.29vw;
background:no-repeat center;
background-size:contain;
width:25.52vw;
height:15.05vw;

}
}.th-TH{
.u_c_0LM773.normal{
position:relative;
width:24.58vw;
height:7.34vw;
background:no-repeat center;
background-size:contain;
margin:auto;
text-align:center;
text-decoration:none;
margin-top:0.52vw;
display:block;
overflow:hidden;

}

.u_c_0LM773.normal.has{
filter:grayscale(1);

}
}.th-TH{
.u_c_ZVYG26.normal{
position:relative;
margin:auto;
text-align:center;
margin-top:2.50vw;

}
}.th-TH{
.u_c_TMWV33.normal{
position:relative;

}
}.th-TH{
.u_c_NRLX34.normal{
position:relative;

}
}.th-TH{
.u_c_TWQV36.normal{
position:relative;

}
}.vi-VN{
.u_c_V3GG18.normal{
position:relative;
width:100.00vw;
height:49.95vw;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/03/1742191580954-2.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}
}.vi-VN{
.u_c_CKWA23.normal{
position:relative;
width:38.23vw;
height:9.95vw;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:2.55vw;
font-size:3.65vw;
color:#dbeaf0;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_CKWA23.normal.text{
width:100%;
height:auto;

}
}.vi-VN{
.u_c_CXUG28.normal{
position:relative;

}
}.vi-VN{
.u_c_09F017.normal{
position:relative;
margin-top:2.19vw;
line-height:1.5;
box-sizing:border-box;
padding:0 1.04vw;
font-size:1.15vw;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;

}
}.vi-VN{
.u_c_EGBY17.normal{
position:relative;
margin:auto;
margin-top:2.29vw;
background:no-repeat center;
background-size:contain;
width:25.52vw;
height:15.05vw;

}
}.vi-VN{
.u_c_0LM773.normal{
position:relative;
width:24.58vw;
height:7.34vw;
background:no-repeat center;
background-size:contain;
margin:auto;
text-align:center;
text-decoration:none;
margin-top:0.52vw;
display:block;
overflow:hidden;

}

.u_c_0LM773.normal.has{
filter:grayscale(1);

}
}.vi-VN{
.u_c_ZVYG26.normal{
position:relative;
margin:auto;
text-align:center;
margin-top:2.50vw;

}
}.vi-VN{
.u_c_TMWV33.normal{
position:relative;

}
}.vi-VN{
.u_c_NRLX34.normal{
position:relative;

}
}.vi-VN{
.u_c_TWQV36.normal{
position:relative;

}
}.de-DE{
.u_c_V3GG18.normal{
position:relative;
width:100.00vw;
height:49.95vw;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/03/1742191580954-2.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}
}.de-DE{
.u_c_CKWA23.normal{
position:relative;
width:38.23vw;
height:9.95vw;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:2.55vw;
font-size:3.65vw;
color:#dbeaf0;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_CKWA23.normal.text{
width:100%;
height:auto;

}
}.de-DE{
.u_c_CXUG28.normal{
position:relative;

}
}.de-DE{
.u_c_09F017.normal{
position:relative;
margin-top:2.19vw;
line-height:1.5;
box-sizing:border-box;
padding:0 1.04vw;
font-size:1.15vw;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;

}
}.de-DE{
.u_c_EGBY17.normal{
position:relative;
margin:auto;
margin-top:2.29vw;
background:no-repeat center;
background-size:contain;
width:25.52vw;
height:15.05vw;

}
}.de-DE{
.u_c_0LM773.normal{
position:relative;
width:24.58vw;
height:7.34vw;
background:no-repeat center;
background-size:contain;
margin:auto;
text-align:center;
text-decoration:none;
margin-top:0.52vw;
display:block;
overflow:hidden;

}

.u_c_0LM773.normal.has{
filter:grayscale(1);

}
}.de-DE{
.u_c_ZVYG26.normal{
position:relative;
margin:auto;
text-align:center;
margin-top:2.50vw;

}
}.de-DE{
.u_c_TMWV33.normal{
position:relative;

}
}.de-DE{
.u_c_NRLX34.normal{
position:relative;

}
}.de-DE{
.u_c_TWQV36.normal{
position:relative;

}
}.fr-FR{
.u_c_V3GG18.normal{
position:relative;
width:100.00vw;
height:49.95vw;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/03/1742191580954-2.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}
}.fr-FR{
.u_c_CKWA23.normal{
position:relative;
width:38.23vw;
height:9.95vw;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:2.55vw;
font-size:3.65vw;
color:#dbeaf0;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_CKWA23.normal.text{
width:100%;
height:auto;

}
}.fr-FR{
.u_c_CXUG28.normal{
position:relative;

}
}.fr-FR{
.u_c_09F017.normal{
position:relative;
margin-top:2.19vw;
line-height:1.5;
box-sizing:border-box;
padding:0 1.04vw;
font-size:1.15vw;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;

}
}.fr-FR{
.u_c_EGBY17.normal{
position:relative;
margin:auto;
margin-top:2.29vw;
background:no-repeat center;
background-size:contain;
width:25.52vw;
height:15.05vw;

}
}.fr-FR{
.u_c_0LM773.normal{
position:relative;
width:24.58vw;
height:7.34vw;
background:no-repeat center;
background-size:contain;
margin:auto;
text-align:center;
text-decoration:none;
margin-top:0.52vw;
display:block;
overflow:hidden;

}

.u_c_0LM773.normal.has{
filter:grayscale(1);

}
}.fr-FR{
.u_c_ZVYG26.normal{
position:relative;
margin:auto;
text-align:center;
margin-top:2.50vw;

}
}.fr-FR{
.u_c_TMWV33.normal{
position:relative;

}
}.fr-FR{
.u_c_NRLX34.normal{
position:relative;

}
}.fr-FR{
.u_c_TWQV36.normal{
position:relative;

}
}.es-ES{
.u_c_V3GG18.normal{
position:relative;
width:100.00vw;
height:49.95vw;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/03/1742191580954-2.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}
}.es-ES{
.u_c_CKWA23.normal{
position:relative;
width:38.23vw;
height:9.95vw;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:2.55vw;
font-size:3.65vw;
color:#dbeaf0;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_CKWA23.normal.text{
width:100%;
height:auto;

}
}.es-ES{
.u_c_CXUG28.normal{
position:relative;

}
}.es-ES{
.u_c_09F017.normal{
position:relative;
margin-top:2.19vw;
line-height:1.5;
box-sizing:border-box;
padding:0 1.04vw;
font-size:1.15vw;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;

}
}.es-ES{
.u_c_EGBY17.normal{
position:relative;
margin:auto;
margin-top:2.29vw;
background:no-repeat center;
background-size:contain;
width:25.52vw;
height:15.05vw;

}
}.es-ES{
.u_c_0LM773.normal{
position:relative;
width:24.58vw;
height:7.34vw;
background:no-repeat center;
background-size:contain;
margin:auto;
text-align:center;
text-decoration:none;
margin-top:0.52vw;
display:block;
overflow:hidden;

}

.u_c_0LM773.normal.has{
filter:grayscale(1);

}
}.es-ES{
.u_c_ZVYG26.normal{
position:relative;
margin:auto;
text-align:center;
margin-top:2.50vw;

}
}.es-ES{
.u_c_TMWV33.normal{
position:relative;

}
}.es-ES{
.u_c_NRLX34.normal{
position:relative;

}
}.es-ES{
.u_c_TWQV36.normal{
position:relative;

}
}.pt-PT{
.u_c_V3GG18.normal{
position:relative;
width:100.00vw;
height:49.95vw;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/03/1742191580954-2.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}
}.pt-PT{
.u_c_CKWA23.normal{
position:relative;
width:38.23vw;
height:9.95vw;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:2.55vw;
font-size:3.65vw;
color:#dbeaf0;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_CKWA23.normal.text{
width:100%;
height:auto;

}
}.pt-PT{
.u_c_CXUG28.normal{
position:relative;

}
}.pt-PT{
.u_c_09F017.normal{
position:relative;
margin-top:2.19vw;
line-height:1.5;
box-sizing:border-box;
padding:0 1.04vw;
font-size:1.15vw;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;

}
}.pt-PT{
.u_c_EGBY17.normal{
position:relative;
margin:auto;
margin-top:2.29vw;
background:no-repeat center;
background-size:contain;
width:25.52vw;
height:15.05vw;

}
}.pt-PT{
.u_c_0LM773.normal{
position:relative;
width:24.58vw;
height:7.34vw;
background:no-repeat center;
background-size:contain;
margin:auto;
text-align:center;
text-decoration:none;
margin-top:0.52vw;
display:block;
overflow:hidden;

}

.u_c_0LM773.normal.has{
filter:grayscale(1);

}
}.pt-PT{
.u_c_ZVYG26.normal{
position:relative;
margin:auto;
text-align:center;
margin-top:2.50vw;

}
}.pt-PT{
.u_c_TMWV33.normal{
position:relative;

}
}.pt-PT{
.u_c_NRLX34.normal{
position:relative;

}
}.pt-PT{
.u_c_TWQV36.normal{
position:relative;

}
}.it-IT{
.u_c_V3GG18.normal{
position:relative;
width:100.00vw;
height:49.95vw;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/03/1742191580954-2.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}
}.it-IT{
.u_c_CKWA23.normal{
position:relative;
width:38.23vw;
height:9.95vw;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:2.55vw;
font-size:3.65vw;
color:#dbeaf0;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_CKWA23.normal.text{
width:100%;
height:auto;

}
}.it-IT{
.u_c_CXUG28.normal{
position:relative;

}
}.it-IT{
.u_c_09F017.normal{
position:relative;
margin-top:2.19vw;
line-height:1.5;
box-sizing:border-box;
padding:0 1.04vw;
font-size:1.15vw;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;

}
}.it-IT{
.u_c_EGBY17.normal{
position:relative;
margin:auto;
margin-top:2.29vw;
background:no-repeat center;
background-size:contain;
width:25.52vw;
height:15.05vw;

}
}.it-IT{
.u_c_0LM773.normal{
position:relative;
width:24.58vw;
height:7.34vw;
background:no-repeat center;
background-size:contain;
margin:auto;
text-align:center;
text-decoration:none;
margin-top:0.52vw;
display:block;
overflow:hidden;

}

.u_c_0LM773.normal.has{
filter:grayscale(1);

}
}.it-IT{
.u_c_ZVYG26.normal{
position:relative;
margin:auto;
text-align:center;
margin-top:2.50vw;

}
}.it-IT{
.u_c_TMWV33.normal{
position:relative;

}
}.it-IT{
.u_c_NRLX34.normal{
position:relative;

}
}.it-IT{
.u_c_TWQV36.normal{
position:relative;

}
}.tr-TR{
.u_c_V3GG18.normal{
position:relative;
width:100.00vw;
height:49.95vw;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/03/1742191580954-2.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}
}.tr-TR{
.u_c_CKWA23.normal{
position:relative;
width:38.23vw;
height:9.95vw;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:2.55vw;
font-size:3.65vw;
color:#dbeaf0;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_CKWA23.normal.text{
width:100%;
height:auto;

}
}.tr-TR{
.u_c_CXUG28.normal{
position:relative;

}
}.tr-TR{
.u_c_09F017.normal{
position:relative;
margin-top:2.19vw;
line-height:1.5;
box-sizing:border-box;
padding:0 1.04vw;
font-size:1.15vw;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;

}
}.tr-TR{
.u_c_EGBY17.normal{
position:relative;
margin:auto;
margin-top:2.29vw;
background:no-repeat center;
background-size:contain;
width:25.52vw;
height:15.05vw;

}
}.tr-TR{
.u_c_0LM773.normal{
position:relative;
width:24.58vw;
height:7.34vw;
background:no-repeat center;
background-size:contain;
margin:auto;
text-align:center;
text-decoration:none;
margin-top:0.52vw;
display:block;
overflow:hidden;

}

.u_c_0LM773.normal.has{
filter:grayscale(1);

}
}.tr-TR{
.u_c_ZVYG26.normal{
position:relative;
margin:auto;
text-align:center;
margin-top:2.50vw;

}
}.tr-TR{
.u_c_TMWV33.normal{
position:relative;

}
}.tr-TR{
.u_c_NRLX34.normal{
position:relative;

}
}.tr-TR{
.u_c_TWQV36.normal{
position:relative;

}
}.pl-PL{
.u_c_V3GG18.normal{
position:relative;
width:100.00vw;
height:49.95vw;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/03/1742191580954-2.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}
}.pl-PL{
.u_c_CKWA23.normal{
position:relative;
width:38.23vw;
height:9.95vw;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:2.55vw;
font-size:3.65vw;
color:#dbeaf0;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_CKWA23.normal.text{
width:100%;
height:auto;

}
}.pl-PL{
.u_c_CXUG28.normal{
position:relative;

}
}.pl-PL{
.u_c_09F017.normal{
position:relative;
margin-top:2.19vw;
line-height:1.5;
box-sizing:border-box;
padding:0 1.04vw;
font-size:1.15vw;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;

}
}.pl-PL{
.u_c_EGBY17.normal{
position:relative;
margin:auto;
margin-top:2.29vw;
background:no-repeat center;
background-size:contain;
width:25.52vw;
height:15.05vw;

}
}.pl-PL{
.u_c_0LM773.normal{
position:relative;
width:24.58vw;
height:7.34vw;
background:no-repeat center;
background-size:contain;
margin:auto;
text-align:center;
text-decoration:none;
margin-top:0.52vw;
display:block;
overflow:hidden;

}

.u_c_0LM773.normal.has{
filter:grayscale(1);

}
}.pl-PL{
.u_c_ZVYG26.normal{
position:relative;
margin:auto;
text-align:center;
margin-top:2.50vw;

}
}.pl-PL{
.u_c_TMWV33.normal{
position:relative;

}
}.pl-PL{
.u_c_NRLX34.normal{
position:relative;

}
}.pl-PL{
.u_c_TWQV36.normal{
position:relative;

}
}.id-ID{
.u_c_V3GG18.normal{
position:relative;
width:100.00vw;
height:49.95vw;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/03/1742191580954-2.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}
}.id-ID{
.u_c_CKWA23.normal{
position:relative;
width:38.23vw;
height:9.95vw;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:2.55vw;
font-size:3.65vw;
color:#dbeaf0;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_CKWA23.normal.text{
width:100%;
height:auto;

}
}.id-ID{
.u_c_CXUG28.normal{
position:relative;

}
}.id-ID{
.u_c_09F017.normal{
position:relative;
margin-top:2.19vw;
line-height:1.5;
box-sizing:border-box;
padding:0 1.04vw;
font-size:1.15vw;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;

}
}.id-ID{
.u_c_EGBY17.normal{
position:relative;
margin:auto;
margin-top:2.29vw;
background:no-repeat center;
background-size:contain;
width:25.52vw;
height:15.05vw;

}
}.id-ID{
.u_c_0LM773.normal{
position:relative;
width:24.58vw;
height:7.34vw;
background:no-repeat center;
background-size:contain;
margin:auto;
text-align:center;
text-decoration:none;
margin-top:0.52vw;
display:block;
overflow:hidden;

}

.u_c_0LM773.normal.has{
filter:grayscale(1);

}
}.id-ID{
.u_c_ZVYG26.normal{
position:relative;
margin:auto;
text-align:center;
margin-top:2.50vw;

}
}.id-ID{
.u_c_TMWV33.normal{
position:relative;

}
}.id-ID{
.u_c_NRLX34.normal{
position:relative;

}
}.id-ID{
.u_c_TWQV36.normal{
position:relative;

}
}.ar-SA{
.u_c_V3GG18.normal{
position:relative;
width:100.00vw;
height:49.95vw;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2025/03/1742191580954-2.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}
}.ar-SA{
.u_c_CKWA23.normal{
position:relative;
width:38.23vw;
height:9.95vw;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:2.55vw;
font-size:3.65vw;
color:#dbeaf0;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_CKWA23.normal.text{
width:100%;
height:auto;

}
}.ar-SA{
.u_c_CXUG28.normal{
position:relative;

}
}.ar-SA{
.u_c_09F017.normal{
position:relative;
margin-top:2.19vw;
line-height:1.5;
box-sizing:border-box;
padding:0 1.04vw;
font-size:1.15vw;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;

}
}.ar-SA{
.u_c_EGBY17.normal{
position:relative;
margin:auto;
margin-top:2.29vw;
background:no-repeat center;
background-size:contain;
width:25.52vw;
height:15.05vw;

}
}.ar-SA{
.u_c_0LM773.normal{
position:relative;
width:24.58vw;
height:7.34vw;
background:no-repeat center;
background-size:contain;
margin:auto;
text-align:center;
text-decoration:none;
margin-top:0.52vw;
display:block;
overflow:hidden;

}

.u_c_0LM773.normal.has{
filter:grayscale(1);

}
}.ar-SA{
.u_c_ZVYG26.normal{
position:relative;
margin:auto;
text-align:center;
margin-top:2.50vw;

}
}.ar-SA{
.u_c_TMWV33.normal{
position:relative;

}
}.ar-SA{
.u_c_NRLX34.normal{
position:relative;

}
}.ar-SA{
.u_c_TWQV36.normal{
position:relative;

}
}
</style>
